import { Injectable } from '@angular/core';
import { StateService } from './state.service';

export interface IDmcOverrideState {
  /** DMC currently being viewed. Null until identity resolves. */
  dmcId: string | null;
  /** Only admins may impersonate, so only their requests carry the override. */
  isAdmin: boolean;
}

/**
 * Holds which DMC the user is acting as, so `dmcOverrideInterceptor` can send
 * `x-dmc-override` without every caller having to thread the id through.
 *
 * Partners never leave their own DMC; admins switch via the dashboard selector.
 */
@Injectable({
  providedIn: 'root',
})
export class DmcOverrideStateService extends StateService<IDmcOverrideState> {
  protected readonly stateName = 'DmcOverrideState';

  constructor() {
    super({ dmcId: null, isAdmin: false });
  }

  readonly dmcId = this.select('dmcId');
  readonly isAdmin = this.select('isAdmin');
}
